import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InnerTemplaterComponent } from './components/inner-templater/inner-templater.component';
import { FbShareModule } from '../fb-share/fb-share.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FbShareModule,
    SharedModule
  ],
  declarations: [InnerTemplaterComponent],
  exports: [InnerTemplaterComponent]
})
export class InnerTemplaterModule { }
